const primaryNav = {

	elem: {
		$primary: $('.header__lower'),
		$primaryNav: $('.header__navigation'),
		$primaryToggle: $('.header__toggle')
	},

	mql: {
		large: window.matchMedia('(min-width: 1024px)')
	},

	init() {
		this.elem.$primaryToggle.on('click', function(e) {
			e.preventDefault();
			$(e.target).attr({
				'aria-pressed': function (i, txt) {
					return (txt === 'false') ? 'true' : 'false';
				},
				'aria-label': function (i, txt) {
					return (txt === 'Open primary navigation') ? txt.replace('Open', 'Close') : txt.replace('Close', 'Open');
				}
			});
			$('html, body').toggleClass('body--no-scroll');	
		});

		$(window).on('resize', this.reset.bind(this));
	},

	reset() {
		if(primaryNav.mql.large.matches) {
			$('html, body').removeClass('body--no-scroll');						
			primaryNav.elem.$primaryNav.removeAttr('style');
			primaryNav.elem.$primaryToggle.attr({
				'aria-pressed': 'false',
				'aria-label': 'Open primary navigation'
			});
		}
	}

};

export { primaryNav };
